import {
  Avatar,
  Box,
  Center,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast
} from "@chakra-ui/react";

import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { BsPeople } from "react-icons/bs";
import { RiSearch2Line } from "react-icons/ri";
import {
  IAssessmentTheoryAnswersData,
  IAssessmentTheoryAnswersQuestion,
} from "../../../../models/assignments/theoryAnswersAssessment.model";
import {
  IUserProfileRes
} from "../../../../models/userprofile.model";
import trainerAssignmentService from "../../../../services/trainer/trainer-assignment.service";
import userService from "../../../../services/user.service";
import Loading from "../../../common/Loading";

export const data = [
  ["Options", "0ption"],
  ["A", 11],
  ["B", 2],
  ["C", 2],
  ["D", 2],
  ["E", 7],
];

export const options = {
  title: "Option Spread",
};

export default function TrQuizAnswers() {
  const navigate = useNavigate();
  const toast = useToast();
  const { assignment_id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isScoreReport, setIsScoreReport] = useState(true);
  useState<IAssessmentTheoryAnswersQuestion[]>();
  const [questions, setQuestions] =
    useState<IAssessmentTheoryAnswersQuestion[]>();
  const [passMark, setPassMark] = useState<number>();
  const [traineesScoreReport, setTraineesScoreReport] = useState<any>([]);
  const [selectedScoreReport, setSelectedScoreReport] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(false);

  function calculatePercentage(numerator: number, denominator: number) {
    if (denominator === 0) {
      return "Denominator cannot be zero";
    }

    const percentage = (numerator / denominator) * 100;
    return percentage.toFixed(2) + "%";
  }

  useEffect(() => {
    if (assignment_id) {
      try {
        trainerAssignmentService
          .getAnsweredAssignmentQuestions(assignment_id)
          .then(async (res) => {
            const response: IAssessmentTheoryAnswersData = res.data;
            if (response.header.user_question_answer.length === 0) {
              // set to empty if no trainee has answered the quiz
              setIsEmpty(true);
            }

            setQuestions(response.questions);
            setPassMark(response.header.pass_mark);

            const groupedData: any = {};

            // Iterate through the array and group objects by their ID
            response.header.user_question_answer.forEach((item) => {
              const id = item.user_id && item.user_id.toString();
              // If the user ID is not in groupedData, create an entry for it
              if (id) {
                if (!groupedData[id]) {
                  groupedData[id] = {
                    profile: null,
                    answers: [],
                    calc_total_score: 0,
                    calc_obtainable_score: 0,
                    percent: 0,
                  };
                }
                // Push the object into the corresponding group's answers array
                groupedData[id].answers.push(item);

                const totals = groupedData[id].answers.reduce(
                  (accumulator: any, answer: any) => {
                    accumulator.totalScore += answer.score;
                    accumulator.totalMark += answer.total_mark;
                    return accumulator;
                  },
                  { totalScore: 0, totalMark: 0 }
                );

                groupedData[id].calc_total_score = totals.totalScore;
                groupedData[id].calc_obtainable_score = totals.totalMark;

                groupedData[id].percent = calculatePercentage(
                  totals.totalScore,
                  totals.totalMark
                );
              }
            });

            const userIdArray: string[] = Object.keys(groupedData);
            for (let index = 0; index < userIdArray.length; index++) {
              const element = userIdArray[index];
              const user: IUserProfileRes = await userService.getUserProfile(
                element
              );
              if (user) {
                groupedData[element].profile = user.data;
              }
            }

            const groupedDataArr = Object.values(groupedData);

            setTraineesScoreReport(groupedDataArr);
            setIsLoading(false);
          });
      } catch (error) {
        console.log(error);
      } finally {
        // setIsLoading(false);
      }
    }
  }, []);

  function getSelectedUser(id: string) {
    setIsScoreReport(false);
    const currentUser = traineesScoreReport.find((each: any) => {
      return  id === each.profile?.id.toString();
    })
    setSelectedScoreReport(currentUser);
  }

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Flex minHeight="100vh" width="100%" bg="white" height={"auto"}>
          <Box
            width="30%"
            borderRight="1px solid"
            pt="35px"
            pl="15px"
            borderColor="lightgray"
          >
            <HStack
              cursor={"pointer"}
              onClick={() => {
                setIsScoreReport(true);
              }}
              spacing="5px"
              pl="15px"
              py="10px"
              bg="#FF961B0A"
            >
              <Center
                width="32px"
                bg="#FFE1E2"
                height="32px"
                borderRadius="16px"
              >
                <BsPeople />
              </Center>
              <Text>Score Report</Text>
            </HStack>
            <Box mt="10px" mb="10px">
              <InputGroup
                variant="flushed"
                height="45px"
                color="#616161"
                bg="white"
                mr="20px"
                width="100%"
              >
                <Input placeholder="Search trainees" fontSize={12} size="sm" />

                <InputRightElement
                  h="1.9rem"
                  pointerEvents="none"
                  children={<RiSearch2Line color="red" size="0.9rem" />}
                />
              </InputGroup>
            </Box>
            {traineesScoreReport &&
              !isEmpty &&
              traineesScoreReport.map((each: any, index: number) => {
                const user = each?.profile;
                return (
                  <HStack
                    onClick={() => {
                      getSelectedUser(user?.id.toString());
                    }}
                    spacing={2}
                    cursor={"pointer"}
                    key={index}
                    pl="15px"
                    mb="10px"
                    borderBottom="1px solid"
                    borderColor="lightgray"
                    pb="10px"
                  >
                    <Avatar size={"sm"} name={user?.name} />
                    <Text fontSize="14px" color="#616161">
                      {user?.name}
                    </Text>
                  </HStack>
                );
              })}
          </Box>
          <Box width="70%" py="20px" pl="60px" pr="50px">
            {isScoreReport && (
              <Box>
                <TableContainer>
                  <Table size={"sm"} variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Trainee Name</Th>
                        <Th textTransform="none">Total Score</Th>
                        <Th textTransform="none">Total Obtainable Score</Th>
                        <Th textTransform="none">Total(%)</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {traineesScoreReport &&
                        !isEmpty &&
                        traineesScoreReport.map((each: any, index: number) => {
                          const user = each?.profile;
                          return (
                            <Tr bg="white" key={index}>
                              <Td>
                                <HStack spacing="10px">
                                  <Avatar name={user && user.name} size="sm" />
                                  <Text
                                    fontWeight="500"
                                    fontSize="13px"
                                    color="#616161"
                                  >
                                    {user && user.name}
                                  </Text>
                                </HStack>
                              </Td>
                              <Td>
                                {" "}
                                <Text textAlign={"center"}>
                                  {each?.calc_total_score}
                                </Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text textAlign={"center"}>
                                  {each?.calc_obtainable_score}
                                </Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text
                                  textAlign={"center"}
                                  fontWeight={"bold"}
                                  color={`${
                                    passMark && each?.percent < passMark
                                      ? "red"
                                      : "green"
                                  }`}
                                >
                                  {each?.percent}
                                </Text>
                              </Td>
                            </Tr>
                          );
                        })}
                      {isEmpty && (
                        <Tr>
                          <Td colSpan={4}>
                            <Text textAlign={"center"} fontWeight={"bold"}>
                              No trainees have answered this quiz
                            </Text>
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {!isScoreReport && (
              <Box>
                <Flex
                  bg="white"
                  pb="30px"
                  pt="20px"
                  boxShadow="base"
                  mb="40px"
                  justifyContent="space-around"
                >
                  <HStack spacing="15px">
                    <Box>
                      <Text color="#959595" fontSize="16px">
                        Total Obtained
                      </Text>

                      <Text fontSize="24px" color="black" fontWeight="600">
                        {selectedScoreReport?.calc_total_score}
                      </Text>
                    </Box>
                  </HStack>

                  <HStack spacing="15px">
                    <Box>
                      <Text color="#959595" fontSize="16px">
                        Total Obtainable
                      </Text>

                      <Text fontSize="24px" color="black" fontWeight="600">
                        {selectedScoreReport?.calc_obtainable_score}
                      </Text>
                    </Box>
                  </HStack>

                  <HStack spacing="15px">
                    <Box>
                      <Text color="#959595" fontSize="16px">
                        Average Score
                      </Text>

                      <Text fontSize="24px" color="black" fontWeight="600">
                        {selectedScoreReport?.percent}
                      </Text>
                    </Box>
                  </HStack>
                </Flex>
                {
                  questions?.map((each: any, index:number) => {
                    const userAnswers = each.users_answers.slice(-1);
                    let isPass = false;
                    if (userAnswers[0]?.score !== 0){
                      isPass = true;
                    }
                    return (
                      <Flex key={index} mb={"15px"}>
                        <Text mr="5px">{index + 1}.</Text>
                        <Box>
                          <Box width="100%">
                            <Text fontSize="16px" color="#616161">
                              {each?.question}
                            </Text>
                          </Box>
                          <Flex
                            flexDirection={"column"}
                            justifyContent={"flex-start"}
                          >
                            <Box
                              fontSize="16px"
                              color="#616161"
                              width="100%"
                              mt="10px"
                            >
                              {each.options.map((each: any, index: number) => {
                                const optionLabel = String.fromCharCode(
                                  65 + index
                                );
                                let isCorrect = false;
                                if (each.is_correct == 1 && isPass) {
                                  isCorrect = true;
                                }
                                return (
                                  <Text
                                    key={index}
                                    mb="5px"
                                    color={`${isCorrect ? "green" : ""}`}
                                    fontWeight={"600"}
                                  >
                                    {optionLabel}. {each.answer}{" "}
                                    {isCorrect ? "(correct answer)" : ""}
                                  </Text>
                                );
                              })}
                            </Box>
                            {!isPass ? (
                              <Text display={"flex"} flexDirection={"row"} alignContent={"center"} gap={"0.4rem"} alignItems={"center"}>Status: <Box height={"auto"} padding={"0.4rem"} borderRadius={"8px"} border={"none"} bg={"red"} width={"fit-content"} color={"white"} fontSize={"small"}>Failed</Box></Text>
                            ) : (
                              <Text display={"flex"} flexDirection={"row"} alignContent={"center"} gap={"0.4rem"} alignItems={"center"}>Status: <Box height={"auto"} padding={"0.4rem"} borderRadius={"8px"} border={"none"} bg={"green"} width={"fit-content"} color={"white"} fontSize={"small"}>Passed</Box></Text>
                            )}
                          </Flex>
                        </Box>
                      </Flex>
                    );
                  })
                }

              </Box>
            )}
          </Box>
        </Flex>
      )}
    </>
  );
}
